import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPatch, operationsClient } from '@/lib/api';
import type { Lead, UpdateLeadStageDto } from '@/types/lead';

export function useUpdateLeadStage() {
  const queryClient = useQueryClient();

  return useApiMutation<Lead, UpdateLeadStageDto>({
    mutationFn: ({ id, stageId }) =>
      apiPatch<Lead, { stageId: string }>(operationsClient, leadEndpoints.update(id), { stageId }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.detail(data.id) });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Stage updated');
    },
    // No `onError` here on purpose. `useApiMutation` already raises
    // `toast.error(error.message)` for every failure and then calls the
    // caller's `onError`, so a handler that toasts again produces two: the
    // server's reason, and a generic line stacked on top competing with it.
    // To suppress rather than duplicate, the supported control is
    // `showErrorToast: false`.
  });
}
